// extracted by mini-css-extract-plugin
export default {"RefSelectorTabs":"RefSelector-module__RefSelectorTabs__JJgsKoc","RefSelectorTabLink":"RefSelector-module__RefSelectorTabLink__nkpkUVZ"};